import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';
import { FadeUp, steps, EYEBROW, GRAD_TEXT } from './shared';

const StepCard = ({ step, index }) => (
  <div data-testid={`how-step-${index}`} className="lift-card" style={{
    padding: '2rem', background: '#fff', flex: 1,
    border: '1px solid rgba(48,43,44,0.1)', borderRadius: '2px',
    transition: 'border-color 0.3s, transform 0.3s, box-shadow 0.3s', height: '100%',
  }}
    onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(246,116,37,0.35)'; e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 20px 40px -12px rgba(246,116,37,0.18)'; }}
    onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(48,43,44,0.1)'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
  >
    <div style={{
      width: '44px', height: '44px', borderRadius: '2px', background: 'rgba(246,116,37,0.08)',
      border: '1px solid rgba(246,116,37,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: '#F67425', marginBottom: '1.25rem',
    }}>{step.icon}</div>
    <span style={{ ...EYEBROW, fontSize: '0.65rem' }}>STEP {step.num}</span>
    <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.125rem', fontWeight: 800, color: '#302B2C', margin: '0.5rem 0' }}>{step.title}</h3>
    <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.875rem', color: 'rgba(48,43,44,0.72)', lineHeight: 1.6, margin: 0 }}>{step.desc}</p>
  </div>
);

const StepArrow = () => (
  <div className="hiw-arrow" aria-hidden="true" style={{
    alignItems: 'center', justifyContent: 'center', color: '#F67425', flexShrink: 0, padding: '0 4px',
  }}>
    <ArrowRight size={22} strokeWidth={2.5} />
  </div>
);

const HowItWorks = ({ onStart }) => (
  <section style={{ padding: '5rem 1.5rem 7rem', maxWidth: '1024px', margin: '0 auto' }}>
    <FadeUp>
      <div style={{ marginBottom: '3.5rem' }}>
        <span style={EYEBROW}>How It Works</span>
        <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(1.5rem, 3vw, 2.25rem)', fontWeight: 800, color: '#302B2C', letterSpacing: '-0.03em', lineHeight: 1.05, marginTop: '0.75rem' }}>
          Three steps to your <span style={GRAD_TEXT}>migration map</span>
        </h2>
      </div>
    </FadeUp>
    <div style={{ display: 'flex', gap: '16px', alignItems: 'stretch', flexWrap: 'wrap' }}>
      {steps.map((step, i) => (
        <React.Fragment key={step.num}>
          <FadeUp delay={i * 0.12} className="hiw-card">
            <StepCard step={step} index={i} />
          </FadeUp>
          {i < steps.length - 1 && <StepArrow />}
        </React.Fragment>
      ))}
    </div>

    {/* Arrow terminating at the CTA */}
    <FadeUp delay={0.4}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '2.5rem', gap: '0.75rem' }}>
        <ArrowDown size={22} strokeWidth={2.5} color="#F67425" className="bob-down" />
        <button onClick={onStart} data-testid="how-it-works-cta" style={{
          display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '14px 32px',
          background: 'linear-gradient(135deg, #F67425, #BB0518)', color: '#fff', border: 'none', borderRadius: '2px',
          fontFamily: 'var(--font-heading)', fontSize: '1rem', fontWeight: 700, cursor: 'pointer',
          boxShadow: '0 4px 16px rgba(246,116,37,0.25)', transition: 'transform 0.2s, box-shadow 0.3s',
        }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.03)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(246,116,37,0.3)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(246,116,37,0.25)'; }}
        >Start Step 1 Now <ArrowRight size={17} /></button>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '7px', fontFamily: 'var(--font-body)', fontSize: '0.75rem', fontWeight: 700, color: '#0B815A' }}>
          <span className="pulse-dot" style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#0B815A' }} />
          Free assessment — limited slots today
        </span>
      </div>
    </FadeUp>
  </section>
);

export default HowItWorks;
